import DialogTemplate from "./dialog/dialog.html";
import DialogController from "./dialog/dialog.controller";
import constants from "../../core/constants";
class Controller {
  constructor(Events, $mdDialog, $injector, Translation, $location) {
    "ngInject";
    this.$location = $location;
    this.$injector = $injector;
    this.Events = Events;
    this.$mdDialog = $mdDialog;
    this.showEdit = true;
    this.Translation = Translation;
    this.onAutocompleteSelectEvent = Events.getUpdateEvent(
      "autocompleteSelectEvent"
    );
  }
  $onInit() {
    const getValues = (obj, city) => {
      if (!obj) return;
      const maximum = obj.maximum / constants.currencyBy;
      const times = obj.times;
      const value = obj.percentage
        ? obj.value
        : obj.value / constants.currencyBy;
      const off = obj.off;
      const percentage = obj.percentage;
      const currency = city.currency;

      return { maximum, times, value, off, percentage, currency };
    };

    const setValues = (obj) => {
      if (obj) {
        this.selected = Object.assign(obj);
        const values = getValues(obj, this.city);
        const languages = this.city.languages;
        if (this.isPercentageAndActualPrice(values)) {
          this.text = this.Translation.translateWithMultiLang(
            "PROMOTION_VALUE_PERCENTAGE",
            values,
            languages
          );
        } else if (this.isAmountAndActualPrice(values)) {
          this.text = this.Translation.translateWithMultiLang(
            "PROMOTION_VALUE_AMOUNT",
            values,
            languages
          );
        } else if (this.isPercentageAndOffOriginalPrice(values)) {
          this.text = this.Translation.translateWithMultiLang(
            "PROMOTION_VALUE_OFF_PERCENTAGE",
            values,
            languages
          );
        } else if (this.isAmountAndOffOriginalPrice(values)) {
          this.text = this.Translation.translateWithMultiLang(
            "PROMOTION_VALUE_OFF_AMOUNT",
            values,
            languages
          );
        }
        this.text = { ...this.text, isDisabled: true };
      }
    };
    setValues(this.selected);
    this.showPromotionDialog = () => {
      this.showEdit = false;
      const add = this.$mdDialog.show({
        controller: DialogController,
        controllerAs: "$ctrl",
        template: DialogTemplate,
        multiple: true,
        locals: {
          selected: getValues(this.selected, this.city),
          currency: this.city.currency,
        },
      });

      add.then(
        (obj) => setValues(obj),
        () => {}
      );
      if (this.$location.absUrl().includes("promotions")) this.showEdit = true;
    };
    this.submitField = () => {
      if (this.eventName) {
        this.showEdit = true;
        this.Events.emit(this.eventName, this.selected);
      }
    };
  }
  isPercentageAndOffOriginalPrice(values) {
    return values.off && values.percentage;
  }
  isAmountAndOffOriginalPrice(values) {
    return values.off && !values.percentage;
  }
  isPercentageAndActualPrice(values) {
    return !values.off && values.percentage;
  }
  isAmountAndActualPrice(values) {
    return !values.off && !values.percentage;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/promotionValue/promotionValue.controller.js